import Agent from 'models/agent';
import createConverter from './lib/create_converter';

export default createConverter(Agent);
